module.exports = __webpack_public_path__ + "img/Entertainment.732d3fd5.png";